import { BillingIntervalEnum, CouponStatusEnum, PlanEnum } from 'enums';
import PropTypes from 'prop-types';

export const PlanDataPropType = PropTypes.shape({
  id: PropTypes.oneOf(Object.values(PlanEnum)).isRequired,
  label: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  currency: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  priceInUSD: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  pricePerMonth: PropTypes.number.isRequired,
  pricePerYear: PropTypes.number.isRequired,
  priceDisplay: PropTypes.string.isRequired,
  pricePerMonthDisplay: PropTypes.string.isRequired,
  pricePerYearDisplay: PropTypes.string.isRequired,
  savings: PropTypes.number,
  savingsDisplay: PropTypes.string.isRequired,
  savingsPercentage: PropTypes.number.isRequired,
  savingsPercentageDisplay: PropTypes.string.isRequired,
});

export const CouponPropType = PropTypes.shape({
  gateway: PropTypes.string.isRequired,
  context: PropTypes.string,
  code: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  plan: PropTypes.oneOf(Object.values(PlanEnum)),
  billingInterval: PropTypes.oneOf(Object.values(BillingIntervalEnum)),
  status: PropTypes.oneOf(Object.values(CouponStatusEnum)).isRequired,
});
